export default __webpack_public_path__ + "static/assets/SL-X-yellow-light.66bf8a03.png";